module.exports = __webpack_public_path__ + "img/article5_7.52b2b66d.jpg";